import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-line",
  "use": "icon-line-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-line\"><defs><style type=\"text/css\"></style></defs><path d=\"M912 761.9v50H112V212h50v549.9h750zM762 362l100 350H212V487l175-225 225 225 150-125z\" p-id=\"2134\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol